import { Component, inject } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { AgentChatStateService } from '../../features/agentic-ai/agent-chat-state.service';
import {
  NetworkConnectivityService,
  OFFLINE_HEADER_MESSAGE,
} from '../../shared/services/network-connectivity.service';

@Component({
  selector: 'app-ai-header',
  imports: [TooltipModule],
  templateUrl: './ai-header.html',
  styleUrl: './ai-header.scss',
})
export class AiHeader {
  protected readonly chatState = inject(AgentChatStateService);
  protected readonly network = inject(NetworkConnectivityService);
  protected readonly offlineHeaderMessage = OFFLINE_HEADER_MESSAGE;

  isHeaderTitleClipped(el: HTMLElement | null | undefined): boolean {
    if (!el) {
      return false;
    }
    return el.scrollWidth > el.clientWidth;
  }
}
